import { styled as a } from "@mui/material";
import i from "../assets/icon-goto-webstore.png.js";
import p from "../assets/image-goto-webstore.jpg.js";
import s from "./ApeironGotoRoundButton.js";
import { useTranslation as m } from "react-i18next";
import { jsx as u } from "react/jsx-runtime";
const d = a(s)`
  .Custom-Container {
    background-color: unset;
    background: url('') padding-box,
      linear-gradient(to right, #b8e0ff, #395c77) border-box;
    padding: 3px;

    .Custom-Link {
      background-image: url(${`"${p}"`});
      background-repeat: repeat;
      background-size: 36px;

      .Custom-Icon-Text {
        gap: 6px;
        .Custom-Icon {
          margin-left: -14px;

          ${(o) => o.theme.breakpoints.up("res768")} {
            width: 96px;
          }
          ${(o) => o.theme.breakpoints.down("res768")} {
            width: 66px;
          }
        }
      }
    }
  }
`, k = (o) => {
  const {
    className: t,
    url: r,
    target: e
  } = o, {
    t: n
  } = m();
  return /* @__PURE__ */ u(d, {
    className: t,
    icon: i.toString(),
    url: r,
    target: e,
    text: n("goto.web_store")
  });
};
export {
  k as default
};
//# sourceMappingURL=GotoWebStore.js.map
